// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cYDA","delete":"styles_delete__1DziA","update":"styles_update__SVBxb","add":"styles_add__1085r"};